export class Size {
  id: number;
  name: string;
  group: number;
  sizeOrder: number;

  constructor(s?: Size) {
    Object.assign(this, s);
  }
}
